import React from 'react';
import { Flex } from '@chakra-ui/react';
import { FormControl } from 'src/components/UI/FormControl';
import MevoInput from 'src/components/Input';
import Typography from 'src/components/Typography';
import { MASKS } from 'src/components/UI/Input/MaskedInput';

interface PersonalDataFieldsProps {
  document: string;
  fullName: string;
  birthDate: string;
  documentError?: string;
  fullNameError?: string;
  birthDateError?: string;
  onDocumentChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFullNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBirthDateChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDocumentBlur: () => void;
  onFullNameBlur: () => void;
  onBirthDateBlur: () => void;
  isDocumentDisabled?: boolean;
  isFullNameDisabled?: boolean;
  isFullNameLoading?: boolean;
}

export function PersonalDataFields({
  document,
  fullName,
  birthDate,
  documentError,
  fullNameError,
  birthDateError,
  onDocumentChange,
  onFullNameChange,
  onBirthDateChange,
  onDocumentBlur,
  onFullNameBlur,
  onBirthDateBlur,
  isDocumentDisabled = false,
  isFullNameDisabled = false,
  isFullNameLoading = false,
}: PersonalDataFieldsProps) {
  return (
    <>
      <Flex mb="20px" align="center" gap="8px">
        <Typography model="body" size="large" weight="bold">
          Dados pessoais
        </Typography>
      </Flex>

      <Flex gap="15px" mb="20px">
        <FormControl isInvalid={!!documentError} flex={1}>
          <MevoInput
            id="document"
            labelText="CPF*"
            type="tel"
            h="45px"
            placeholder="000.000.000-00"
            name="document"
            value={document}
            onChange={onDocumentChange}
            onBlur={onDocumentBlur}
            errorText={documentError}
            mask={MASKS.CPF}
            disabled={isDocumentDisabled}
          />
        </FormControl>

        <FormControl isInvalid={!!birthDateError} flex={1}>
          <MevoInput
            labelText="DATA DE NASCIMENTO*"
            type="tel"
            h="45px"
            placeholder="00/00/0000"
            name="birthDate"
            value={birthDate}
            onChange={onBirthDateChange}
            onBlur={onBirthDateBlur}
            errorText={birthDateError}
            mask={MASKS.BIRTH_DATE}
          />
        </FormControl>
      </Flex>

      <FormControl isInvalid={!!fullNameError} mb="20px">
        <MevoInput
          id="fullName"
          labelText="NOME COMPLETO*"
          h="45px"
          placeholderText="Digite seu nome completo"
          name="fullName"
          value={fullName}
          onChange={onFullNameChange}
          onBlur={onFullNameBlur}
          errorText={fullNameError}
          disabled={isFullNameDisabled || isFullNameLoading}
          isLoading={isFullNameLoading}
        />
      </FormControl>
    </>
  );
}
